import React, { Component } from 'react';
import classNames from 'classnames';
import LazyLoad from 'react-lazyload';
import { Map } from 'immutable';
import './style.scss';

class LazyLoadWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      error: false,
    };
  }

  render() {
    const { lazyload: shouldLazyLoad, children } = this.props;
    const placeholder = (
      <img
        className="lazy"
        src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
        alt="placeholder"
      />
    );

    if (!shouldLazyLoad) {
      return children;
    }

    const addOnLoadCallback = (element) => {
      const newProps = {};

      newProps.onLoad = (event) => {
        this.setState({ loaded: true });
      };

      newProps.onError = (event) => {
        this.setState({ error: true });
      };

      let childs = [];
      const elementMap = Map(element);
      if (Array.isArray(elementMap.getIn(['props', 'children']))) {
        childs = React.Children.map(element.props.children, (child) => {
          return addOnLoadCallback(child);
        });
      }

      return React.cloneElement(element, newProps, ...childs);
    };

    const { loaded, error } = this.state;
    const classes = classNames('LazyLoadWrapper', {
      'has-loaded': loaded,
      'has-error': error,
    });

    return (
      <LazyLoad placeholder={placeholder} offset={200} once>
        <div className={classes}>
          <div className="lazy-load--inner-wrapper">
            {React.Children.map(children, (child) => {
              return addOnLoadCallback(child);
            })}
          </div>
        </div>
      </LazyLoad>
    );
  }
}

export default LazyLoadWrapper;
